import React, { type ReactNode } from 'react';

import { Trans } from 'react-i18next';

import { Sheet } from '@pkg/components';
import { useGenerateInvite, useMembersPanel } from '@pkg/hooks';
import { useMediaQuery } from '@pkg/providers';

import { Typography } from '../../../../../../../../DesignSystem';
import { ActionBanner, ActionBannerTextHighlight } from '../index';

export interface FooterProps {
    children?: ReactNode;
}

export function Footer({ children }: FooterProps) {
    const { tablet } = useMediaQuery();

    const groupId = useMembersPanel()?.groupId;

    const {
        getCtaActionContent,
        ctaAriaLabel,
        inviteGenerated,
        handleGenerateInvite,
        invitesRemaining,
        inviteGenerationDisabled,
    } = useGenerateInvite();

    return (
        <Sheet.Layout.Footer>
            <Sheet.Layout.Divider>
                <Trans ns="groups" i18nKey="pods_members_invite_panel_divider">
                    <Typography type="label" variant="span" faded>
                        0
                    </Typography>
                    <Typography type="label" variant="span">
                        1
                    </Typography>
                </Trans>
            </Sheet.Layout.Divider>

            <ActionBanner
                actionContent={getCtaActionContent()}
                ariaLabel={ctaAriaLabel}
                disabled={inviteGenerationDisabled}
                success={inviteGenerated && !inviteGenerationDisabled}
                onAction={() => handleGenerateInvite(groupId)}
            >
                <Typography type={tablet ? 'label' : 'paragraph'} size={16} variant="span">
                    <Trans ns="invites" i18nKey="invites_remaining" count={invitesRemaining}>
                        <ActionBannerTextHighlight $error={invitesRemaining === 0}>0</ActionBannerTextHighlight>
                    </Trans>
                </Typography>
            </ActionBanner>

            {children}
        </Sheet.Layout.Footer>
    );
}
